import { TitleDescription as AntdTitleDescription } from "@empglabs/backoffice-ui-kit"

const TitleDescription = props => {
  return <AntdTitleDescription {...props} />
}

export default TitleDescription
